jQuery(function($) {

});


if (document.querySelector('.wp-admin')) {

    wp.domReady( () => {
        /*========= Button =========*/
        wp.blocks.registerBlockStyle('core/button', {
            name: 'fill-green',
            label: 'Fill - Green'
        });

        wp.blocks.registerBlockStyle('core/button', {
            name: 'border-green',
            label: 'Outline - Green'
        });

        wp.blocks.registerBlockStyle('core/button', {
            name: 'with-arrow',
            label: 'With Arrow'
        });

        wp.blocks.registerBlockStyle('core/button', {
            name: 'with-arrow-white',
            label: 'With Arrow (White)'
        });

        wp.blocks.registerBlockStyle('core/button', {
            name: 'transparent-and-no-padding',
            label: 'Transparent and no padding'
        });

        /*========= Group =========*/ 
        wp.blocks.registerBlockStyle('core/group', {
            name: 'rounded-bottom',
            label: 'Rounded bottom'
        });

        wp.blocks.registerBlockStyle('core/group', {
            name: 'rounded-top',
            label: 'Rounded top'
        });

        wp.blocks.registerBlockStyle('core/group', {
            name: 'rounded-bottom-and-top',
            label: 'Rounded bottom & top'
        });

        wp.blocks.registerBlockStyle('core/group', {
            name: 'bg-shield-icon',
            label: 'Shield icon background'
        });

        wp.blocks.registerBlockStyle('core/group', {
            name: 'bg-shield-icon-and-rounded-bottom',
            label: 'Shield icon background and rounded bottom'
        });

        /*========= Image =========*/
        wp.blocks.registerBlockStyle('core/image', {
            name: 'rounded-small',
            label: 'Rounded small'
        });

        /*========= Details =========*/
        wp.blocks.registerBlockStyle('core/details', {
            name: 'upgraded',
            label: 'Upgraded'
        });

        /*========= Post terms (categories) =========*/ 
        wp.blocks.registerBlockStyle('core/post-terms', {
            name: 'rounded-bg-secondary',
            label: 'Rounded full with secondary background'
        });

        /*========= Read more =========*/ 
        wp.blocks.registerBlockStyle('core/read-more', {
            name: 'with-arrow',
            label: 'With Arrow'
        });

        wp.blocks.registerBlockStyle('core/read-more', {
            name: 'with-arrow-white',
            label: 'With Arrow (White)'
        });

        /*========= Cover =========*/ 
        wp.blocks.registerBlockStyle('core/cover', {
            name: 'rounded-medium',
            label: 'Rounded medium'
        });



        /*========= Cover =========*/ 
        wp.blocks.registerBlockStyle('core/paragraph', {
            name: 'line-clamp-4',
            label: '4 lines clamp'
        });



        /*========= Query Pagination Next =========*/
        wp.blocks.registerBlockStyle('core/query-pagination-next', {
            name: 'with-arrow',
            label: 'With Arrow'
        });


        /*========= Query Pagination Next =========*/
        wp.blocks.registerBlockStyle('core/query-pagination-previous', {
            name: 'with-arrow-reverse',
            label: 'With Arrow (reverse)'
        });
    });
}
